import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  divider: {
    width: { xs: "289px" },
    border: `0.5px solid ${theme.palette.white.main}`,
    mt: { xs: "45px" },
  },
  img: {
    width: "26px",
    height: "26px",
  },
  box: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  child: {
    display: "flex",
    mt: { xs: "36px" },
    justifyContent: { xs: "center" },
  },
  text: {
    fontSize: { xs: "28px" },
    lineHeight: { xs: "36px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    color: theme.palette.blue.fifth,
    ml: { xs: "5px" },
  },
  description: {
    fontSize: { xs: "26px" },
    lineHeight: { xs: "36px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    color: theme.palette.blue.fifth,
    mt: { xs: "7px" },
  },
});

const ATypicalDayMobile = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const componentName = "ATypicalDayMobile";
  const translation = useTranslation(pathname, componentName);
  const { data, clockImg } = translation;

  return (
    <Box sx={classes.box}>
      {data.map((item, index) => {
        const { text, description, width } = item;
        return (
          <div key={index}>
            <Box sx={classes.child}>
              <img src={clockImg.src} alt={clockImg.alt} styles={classes.img} />
              <Typography sx={classes.text}>{text}</Typography>
            </Box>
            <Typography sx={{ ...classes.description, width }}>
              {description}
            </Typography>
          </div>
        );
      })}
    </Box>
  );
};

export default ATypicalDayMobile;
